import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';

import { QueryStringTypesEnum } from 'src/app/configs/query-string-types';
import {
  CustomResultOfLoginAuditVm,
  LoginAuditDto,
  LoginDocuments,
} from 'src/app/core/api/models';
import { SuperAdminsService } from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { BaseIndexPageComponent } from 'src/app/pages/shared/base';

@Component({
    selector: 'app-login-audits',
    templateUrl: './login-audits.component.html',
    standalone: false
})
export class LoginAuditsComponent
  extends BaseIndexPageComponent
  implements OnInit
{
  //#region Properties

  pageName = 'loginAudits';
  modelWithPagination$: Observable<CustomResultOfLoginAuditVm>;
  items$: Observable<Array<LoginAuditDto>>;

  //details
  showDetails: boolean = false;
  detailModel: LoginDocuments;
  requestBody: string;

  @Output('hideLoginAuditPage') output_hideLoginAuditPage =
    new EventEmitter<boolean>();

  //#endregion

  constructor(protected currentService: SuperAdminsService) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.pageConfig.showAddBtn = false;
      this.pageConfig.showRefreshBtn = true;
      this.pageConfig.showAuditBtn = false;
      this.pageConfig.tableConfig.pageSizes = [30, 40, 50, 60, 80, 100];
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  setPageAfterEnterUrl() {
    super.setPageAfterEnterUrl();
    // وارد میشود چک میکنیم که کدام جدول باید نمایش داده شود url زمانی که کاربر با
    let params = this.routingState.parseQueryString();
    for (const [key, value] of Object.entries(params)) {
      if (key == QueryStringTypesEnum.Details_key) this.onDetail({}, false);
    }
  }

  configTableColumns() {
    this.tableVocabs = this.pageVocabs + 'fields.';

    this.tableColumns = [
      {
        title: 'common.userName',
        name: 'Document.UserName',
        hasSearch: true,
        noSorting: true,
        type: 'auditText',
      },
      {
        title: `${this.tableVocabs}logDateTime`,
        name: 'Document.LogDateTime',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: `${this.tableVocabs}startDate`,
        name: 'Document.StartDate',
        hasSearch: true,
        type: 'dateTime',
      },
      {
        title: `${this.tableVocabs}endDate`,
        name: 'Document.EndDate',
        hasSearch: true,
        type: 'dateTime',
      },
    ];
  }

  setDefaultTableSort() {
    try {
      this.sortObject.push({ columnName: 'Document.StartDate', sort: 1 });
    } catch (error) {
      this.loggerService.logError(
        this.tagName,
        error,
        EventTypes.infrastructure
      );
    }
  }

  getPaginationApi(): Observable<CustomResultOfLoginAuditVm> {
    return this.currentService.superAdminsGetLoginAuditWithPagination({
      body: this.getBaseModelWithPaginationParams(),
    });
  }

  onDetail(model: LoginDocuments, setFiltersAndUrl = true) {
    this.showParent = false;
    this.setParentQueryString();
    if (setFiltersAndUrl) {
      this.location.go(
        window.location.pathname +
          '?' +
          QueryStringTypesEnum.Details_key +
          '=' +
          JSON.stringify(model)
      );
    }
    this.showDetails = true;
    this.detailModel = model;
  }

  onCloseDetail(event) {
    this.showDetails = false;
  }

  emitOnBack() {
    this.output_hideLoginAuditPage.emit(true);
  }
  
}
